module.exports = "https://cdn.realtymogul.com/static/media/img_panel_1031.16f58e6d.jpg";